import React from "react";
import PropTypes from "prop-types";

function CollectionSectionTitleItem({ title }) {
    return (
        <div className="CollectionCortisSectionTitle">
            <h2 className="CollectionCortisSectionTitle-text">{title}</h2>
        </div>
    );
}

CollectionSectionTitleItem.propTypes = {
    title: PropTypes.string,
};

export default React.memo(CollectionSectionTitleItem);
